// src/components/admin/AdminHeader.js
import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const AdminHeader = () => {
  const navigate = useNavigate();
  const [vehicleAnchor, setVehicleAnchor] = useState(null);
  const [categoryAnchor, setCategoryAnchor] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: 'primary.main', mb: 2 }}>
      <Toolbar>
        <Typography variant="h6" component={Link} to="/admin/home"
          sx={{ flexGrow: 1, color: 'inherit', textDecoration: 'none', fontWeight: 700 }}>
          İrem Oto Admin
        </Typography>

        <Button color="inherit" component={Link} to="/admin/home">
          Dashboard
        </Button>

        {/* Kategori Dropdown */}
        <Button
          color="inherit"
          endIcon={<KeyboardArrowDownIcon />}
          onClick={(e) => setCategoryAnchor(e.currentTarget)}
        >
          Kategoriler
        </Button>
        <Menu
          anchorEl={categoryAnchor}
          open={Boolean(categoryAnchor)}
          onClose={() => setCategoryAnchor(null)}
        >
          <MenuItem component={Link} to="/admin/producttypes" onClick={() => setCategoryAnchor(null)}>
            Ürün Tipleri
          </MenuItem>
          <MenuItem component={Link} to="/admin/productsubtypes" onClick={() => setCategoryAnchor(null)}>
            Ürün Alt Tipleri
          </MenuItem>
        </Menu>

        <Button color="inherit" component={Link} to="/admin/products">
          Ürünler
        </Button>

        {/* Araç Yönetimi Dropdown */}
        <Button
          color="inherit"
          endIcon={<KeyboardArrowDownIcon />}
          onClick={(e) => setVehicleAnchor(e.currentTarget)}
        >
          Araç Yönetimi
        </Button>
        <Menu
          anchorEl={vehicleAnchor}
          open={Boolean(vehicleAnchor)}
          onClose={() => setVehicleAnchor(null)}
        >
          <MenuItem component={Link} to="/admin/vehicles/brands" onClick={() => setVehicleAnchor(null)}>
            Markalar
          </MenuItem>
          <MenuItem component={Link} to="/admin/vehicles/models" onClick={() => setVehicleAnchor(null)}>
            Modeller
          </MenuItem>
          <MenuItem component={Link} to="/admin/vehicles/series" onClick={() => setVehicleAnchor(null)}>
            Seriler / Nesiller
          </MenuItem>
        </Menu>

        <Button color="inherit" component={Link} to="/" sx={{ ml: 1 }}>
          Siteye Git
        </Button>

        <Button color="inherit" onClick={handleLogout} sx={{ ml: 1 }}>
          Çıkış
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;
